export default __webpack_public_path__ + "static/WorkloadCycle-698a40929170288732627eb6f339221f.png";